import { useQuery } from "@tanstack/react-query";
import { globalSearchService } from "@/services/global-search-service";

export const globalSearchKeys = {
  all: ["globalSearch"] as const,
  query: (
    scope: "hotel" | "tenant" | "none",
    scopeId: string | undefined,
    query: string,
  ) => [...globalSearchKeys.all, scope, scopeId, query] as const,
};

interface UseGlobalSearchParams {
  hotelId?: string;
  tenantId?: string;
  query: string;
}

export const useGlobalSearch = ({
  hotelId,
  tenantId,
  query,
}: UseGlobalSearchParams) => {
  const normalizedQuery = query.trim();
  let scope: "hotel" | "tenant" | "none" = "none";

  if (hotelId) {
    scope = "hotel";
  } else if (tenantId) {
    scope = "tenant";
  }

  const scopeId = hotelId ?? tenantId;

  return useQuery({
    queryKey: globalSearchKeys.query(scope, scopeId, normalizedQuery),
    queryFn: ({ signal }) =>
      globalSearchService.search(
        {
          query: normalizedQuery,
        },
        {
          disableToast: true,
          signal,
        },
      ),
    enabled: normalizedQuery.length >= 2,
  });
};
